import type { StoryConversationSession } from '@/features/story-conversation/conversationSession'

interface CommandOwner {
  commands: StoryConversationSession
  readGeneration: number
}

/** A story change excludes generation and retires reads of the preceding timeline. */
export async function runRoleplayCommand<T>(owner: CommandOwner, kind: 'mutation' | 'fork', action: () => Promise<T>): Promise<T | null> {
  const operation = owner.commands.begin(kind)
  if (!operation) return null
  owner.readGeneration++
  try {
    const result = await action()
    return operation.isCurrent() ? result : null
  } finally {
    // Reads started during a change may also contain its pre-commit state.
    if (operation.epoch === owner.commands.state.epoch) owner.readGeneration++
    operation.finish()
  }
}
